import OspreyCustomRequestCreate from './custom-request-create'
import OspreyAudienceGetById from './audience-get-by-id'
import OspreyAudienceMetadata from './audience-metadata'
import OspreyAudienceSearch from './audience-search'
import OspreyAudienceSearchSuggestion from './audience-search-suggestion'
import OspreyAudienceEstimatedConsumers from './audience-estimated-consumers'
import OspreyAudienceTotalConsumers from './audience-total-consumers'
import OspreyAudienceDelete from './audience-delete'

export default class Audiences {

    customRequestCreate(...args) {
        return new OspreyCustomRequestCreate(...args)
    }

    search(...args) {
        return new OspreyAudienceSearch(...args)
    }

    getSearchSuggestion(...args) {
        return new OspreyAudienceSearchSuggestion(...args)
    }

    getMetadata() {
        return new OspreyAudienceMetadata()
    }

    getById(...args) {
        return new OspreyAudienceGetById(...args)
    }

    getEstimateConsumers(...args) {
        return new OspreyAudienceEstimatedConsumers(...args)
    }

    getTotalConsumers(...args) {
        return new OspreyAudienceTotalConsumers(...args)
    }

    deleteAudience(...args) {
        return new OspreyAudienceDelete(...args)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/index.js